import { Input, Button, Form } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { addDataVersion, modifyDataVersion } from "./dataVersionSlice";
import { CommonContext, CommonContextType } from "../../contexts/CommonContext";
import TextArea from "antd/es/input/TextArea";
import { getUser } from "../../services/localStorage";

export default function AddDataVersion(): JSX.Element {
  const dispatch = useDispatch();
  const { setModelChange, messageApi, editBodySize, setEditBodySize } =
    React.useContext(CommonContext) as CommonContextType;
  const [form] = Form.useForm();
  const [version_no, setVersion_value] = React.useState('');
  let pattern = /^[0-9][\.\d]*(\d+)?$/;
  React.useEffect(() => {
    if (editBodySize?.id) {

      form.setFieldsValue(editBodySize);
    }
    else {
      form.resetFields();
    }
  }, [editBodySize, form]);

  const onFinish = (values: any) => {
    const currentUser = JSON.parse(getUser() || '{}');
    values.user = currentUser.id;
    if (editBodySize?.id) {
      values.updated_datetime = new Date().toLocaleString() + "";
      dispatch(modifyDataVersion(values, editBodySize?.id));
    } else {
      values.created_datetime = new Date().toLocaleString() + "";
      dispatch(addDataVersion(values));
      /* messageApi.open({
        type: "success",
        content: "Data Version added successfully",
      }); */
    }
    setModelChange(false);
    setEditBodySize(null);
    form.resetFields();
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  const handleOnChange = (e: any) => {
    setVersion_value(e.target.value);
  };
  return (
    <Form
      form={form}
      layout={"vertical"}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="Data Version"
        name="version_no"
        rules={[
          {
            required: true,
            message: "Please enter version",
          },
          {
            pattern: /^[0-9][\.\d]*(,\d+)?$/,
            message: "Please enter a valid version no, ex: 0.0.0",
          },
        ]}
      >
        <Input id="version_no" onChange={handleOnChange} />
      </Form.Item>

      <Form.Item
        label="Remarks"
        name="remarks"
        rules={[
          {
            required: true,
            message: "Please enter remark",
          }
        ]}
      >
        <TextArea rows={2} />
      </Form.Item>

      <Form.Item>
        <Button disabled={pattern.test(version_no) ? false : true} className='submit-button' type="primary" htmlType="submit" >{editBodySize?.id ? 'Update' : 'Create'}</Button>
      </Form.Item>
    </Form>
  );
}
